import { useMemo } from 'react';

import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { nestedFieldValueGetter } from 'utils/grid';

import { GridColDef, GridColType } from '@mui/x-data-grid-pro';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
import { isSDBAccount } from 'utils/misc';

const useColumnDefinitions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    return generateColumns(t);
  }, [t]);
};

const generateColumns = (t: TFunction): GridColDef[] => [
  ...(isSDBAccount()
    ? [
        {
          field: 'grantName',
          headerName: t('grants.modules.grid.moduleName'),
          type: 'string' as GridColType,
          flex: 2
        }
      ]
    : []),
  {
    field: 'description',
    headerName: t('grants.modules.grid.grantName'),
    type: 'string' as GridColType,
    flex: 2,
    valueGetter: (_, row) =>
      row.grantName
        ? t([`grants.modules.module_description.${row.grantName}`])
        : ''
  },
  {
    field: 'enabled',
    headerName: t('grants.modules.grid.enabled'),
    type: 'boolean' as GridColType,
    flex: 1,
    renderCell: BooleanCell,
    valueGetter: (_, row) => nestedFieldValueGetter('enabled', row)
  }
];

export default useColumnDefinitions;
